
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.25 2.99996C8.16002 2.85996 3.99002 6.93996 3.99002 12H2.20002C1.75002 12 1.53002 12.54 1.85002 12.85L4.64002 15.65C4.84002 15.85 5.15002 15.85 5.35002 15.65L8.14002 12.85C8.46002 12.54 8.23002 12 7.79002 12H5.99002C5.99002 8.09996 9.17002 4.94996 13.09 4.99996C16.81 5.04996 19.94 8.17996 19.99 11.9C20.04 15.81 16.89 19 12.99 19C11.38 19 9.89002 18.45 8.71002 17.52C8.31002 17.21 7.75002 17.24 7.39002 17.6C6.97002 18.03 7.00002 18.73 7.47002 19.1C8.99002 20.29 10.91 21 12.99 21C18.04 21 22.13 16.83 21.99 11.74C21.86 7.04996 17.94 3.12996 13.25 2.99996ZM12.74 7.99996C12.33 7.99996 11.99 8.33996 11.99 8.74996V12.43C11.99 12.78 12.18 13.11 12.48 13.29L15.6 15.14C15.96 15.35 16.42 15.23 16.63 14.88C16.84 14.52 16.72 14.06 16.37 13.85L13.49 12.14V8.73996C13.49 8.33996 13.16 7.99996 12.74 7.99996Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-restore`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconRestore

    ```js
    <b-new-b-icon-restore />
    ```
</docs>


